const translations: Record<string, Record<string, string>> = {
  en: {
    'navbarfooter.termsuse': 'Terms of Use',
    'navbarfooter.serviceagreement': 'Service Agreement',
    'navbarfooter.privacypolicy': 'Privacy Policy',
    'navbarfooter.cookiespolicy': 'Cookies Policy',
    'navbarfooter.cookieSettings': 'Cookie Settings',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Enter your email',
    'register.emailInputTitle': 'Email address',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Create account',
    'actions.back': 'Back',

    'register.checkEmail': 'Check your inbox',
    'register.checkSpam2': 'Remember to check your spam folder as well',
  },
  es: {
    'navbarfooter.termsuse': 'Condiciones de uso',
    'navbarfooter.serviceagreement': 'Acuerdo de servicio',
    'navbarfooter.privacypolicy': 'Política de privacidad',
    'navbarfooter.cookiespolicy': 'Política de cookies',
    'navbarfooter.cookieSettings': 'Configuración de cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Introduce tu correo electrónico',
    'register.emailInputTitle': 'Dirección de correo',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Crear cuenta',
    'actions.back': 'Volver',

    'register.checkEmail': 'Revisa tu bandeja de entrada',
    'register.checkSpam2': 'Recuerda revisar también la carpeta de spam',
  },
  pt: {
    'navbarfooter.termsuse': 'Termos de uso',
    'navbarfooter.serviceagreement': 'Contrato de serviço',
    'navbarfooter.privacypolicy': 'Política de privacidade',
    'navbarfooter.cookiespolicy': 'Política de cookies',
    'navbarfooter.cookieSettings': 'Configuração de cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Insira seu e-mail',
    'register.emailInputTitle': 'Endereço de e-mail',
    'register.emailInputPlaceHolder': 'E-mail',
    'register.createAccount': 'Criar conta',
    'actions.back': 'Voltar',

    'register.checkEmail': 'Verifique sua caixa de entrada',
    'register.checkSpam2': 'Não se esqueça de verificar a pasta de spam também',
  },
  it: {
    'navbarfooter.termsuse': 'Termini di utilizzo',
    'navbarfooter.serviceagreement': 'Accordo di servizio',
    'navbarfooter.privacypolicy': 'Informativa sulla privacy',
    'navbarfooter.cookiespolicy': 'Informativa sui cookie',
    'navbarfooter.cookieSettings': 'Impostazioni cookie',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Inserisci la tua email',
    'register.emailInputTitle': 'Indirizzo email',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Crea account',
    'actions.back': 'Indietro',

    'register.checkEmail': 'Controlla la tua casella di posta',
    'register.checkSpam2': 'Ricorda di controllare anche la cartella spam',
  },
  fr: {
    'navbarfooter.termsuse': "Conditions d'utilisation",
    'navbarfooter.serviceagreement': 'Contrat de service',
    'navbarfooter.privacypolicy': 'Politique de confidentialité',
    'navbarfooter.cookiespolicy': 'Politique de cookies',
    'navbarfooter.cookieSettings': 'Paramètres des cookies',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Entrez votre email',
    'register.emailInputTitle': 'Adresse e-mail',
    'register.emailInputPlaceHolder': 'Email',
    'register.createAccount': 'Créer un compte',
    'actions.back': 'Retour',

    'register.checkEmail': 'Vérifiez votre boîte de réception',
    'register.checkSpam2': 'N’oubliez pas de vérifier le dossier spam également',
  },
  de: {
    'navbarfooter.termsuse': 'Nutzungsbedingungen',
    'navbarfooter.serviceagreement': 'Servicevereinbarung',
    'navbarfooter.privacypolicy': 'Datenschutzrichtlinie',
    'navbarfooter.cookiespolicy': 'Cookie-Richtlinie',
    'navbarfooter.cookieSettings': 'Cookie-Einstellungen',
    'navbarfooter.copyrightRoca': '&copy; Copyright 2025. Roca Sanitario, S.A',
    'navbarfooter.copyrightLaufen': '&copy; Copyright 2025. LAUFEN Bathrooms AG',

    'register.enterEmail': 'Geben Sie Ihre E-Mail-Adresse ein',
    'register.emailInputTitle': 'E-Mail-Adresse',
    'register.emailInputPlaceHolder': 'E-Mail eingeben',
    'register.createAccount': 'Konto erstellen',
    'actions.back': 'Zurück',

    'register.checkEmail': 'Überprüfen Sie Ihren Posteingang',
    'register.checkSpam2': 'Vergessen Sie nicht, auch den Spam-Ordner zu prüfen',
  },
};

const allLanguages = ['en', 'es', 'pt', 'it', 'fr', 'de'];
const laufenLanguages = allLanguages;
const rocaLanguages = ['en', 'es'];

export const translate = (key: string, langOverride?: string, brandCode?: number | string): string => {
  const brandLangs = brandCode === 14 ? rocaLanguages : brandCode === 11 ? laufenLanguages : allLanguages;

  const rawLang = langOverride?.toLowerCase() || navigator.language?.split('-')[0]?.toLowerCase() || 'en';
  const finalLang = brandLangs.includes(rawLang) ? rawLang : 'en';

  return translations[finalLang]?.[key] ?? key;
};
